import api from './APIService';

class SponsorService {
	getAll(id) {
		return api.fetch({ method: 'get', path: '/participant/sponsor/' + id });
	}
	create(data) {
		return api.fetch({ method: 'post', path: '/participant/sponsor/', data });
	}
	update(data) {
		return api.fetch({ method: 'put', path: '/participant/sponsor/', data });
	}
	delete(idUser, id) {
		return api.fetch({ method: 'delete', path: '/participant/sponsor/' + idUser + '/' + id });
	}
	getMultipleSponsor(data) {
		return api.fetch({ method: 'post', path: '/participant/sponsor/getMultipleSponsor', data });
	}
	getSponsorsUsers(data) {
		return api.fetch({ method: 'post', path: '/participant/sponsor/getSponsorsUsers', data });
	}
}

export default new SponsorService();
